export const eventHasSpiideoSchedulingTab = (event) => {
    if (!event) {
        return false;
    }

    if (true === event.has_spiideo_integration) {
        return true;
    }

    if (null != event.spiideo_event?.id) {
        return true;
    }

    return 0 < (event.spiideo_reconciliation_attempts?.length ?? 0);
};
